<template>
  <CheckupContainer />
</template>

<script lang="ts">
import Vue from "vue";
import CheckupContainer from "@/components/checkups/checkup/container/CheckupContainer.vue";

export default Vue.extend({
  components: {
    CheckupContainer,
  },
});
</script>
